import React, { useEffect } from "react"
import { Twitter } from "reactjs-social-embed"

import { graphql } from "gatsby"
import { EmbedSocialMediaV2FieldsFragment } from "../../../../../../graphql-types"

import * as styles from "./embed-social-media-v2.module.scss"
import { elementOffset, transformItem } from "../../../functions/functions"

type EmbedSocialMediaProps = {
  data: EmbedSocialMediaV2FieldsFragment
}

const EmbedSocialMedia: React.FC<EmbedSocialMediaProps> = ({ data }) => {
  const displaySocialMediaEmbed = (post: EmbedSocialMediaV2FieldsFragment["embedSocialPosts"][number]): JSX.Element => {
    if (post.embedTwitter && post.twitterEmbedLink)
      return <Twitter id={post.twitterEmbedLink} parentClass={styles.twitter} />
    if (post.embedLinkedin && post.linkedinEmbedLink) {
      // concatenate the linkedin link with the embed link
      const linkedin_link = "https://www.linkedin.com/embed/feed/update/urn:li:share:" + post.linkedinEmbedLink 
      console.log("linkedin_link:", linkedin_link);
      return (
        <iframe
        src={linkedin_link}
        width="504"
        height={post.linkedinEmbedHeight || "1000"}
        style={{ border: '1px solid var(--black-25, rgba(0, 0, 0, 0.25))', borderRadius: '8px', marginTop: '10px', maxWidth: '550px'}}
        allowFullScreen
        title="LinkedIn Post Embed"
        className={styles.linkedin}
      />
      )
    }
  }

  return (
    <section className={styles.container}>
      <div className={styles.embedGrid}>
        {data.embedSocialPosts.map((post, index) => {
          if (post.embedTwitter || post.embedLinkedin) {
            return (
              <div key={index} className={styles.embedItem}>
                {displaySocialMediaEmbed(post)}
              </div>
            )
          }
        })}
      </div>
    </section>
  )
}

export const fragment = graphql`
  fragment EmbedSocialMediaV2Fields on DatoCmsEmbedSocialMediaV2 {
    __typename
    id
    embedSocialPosts {
      embedTwitter
      twitterEmbedLink
      embedLinkedin
      linkedinEmbedLink
      linkedinEmbedHeight
    }
  }
`

export default EmbedSocialMedia
